import Trans from 'next-translate/Trans';

import { Box, Link, Typography } from '@core/component';
import { Translate } from '@core/constant';
import { useContextCurrency } from '@core/context';
import { useLanguage } from '@core/hook';
import { EActionAttribute, EColor, EFontWeight, EIcon, ETypographyVariant } from '@core/type';
import { formatCurrency } from '@core/util';

import { LinkRecommendationProps } from '../interface-product-show';

export const LinkRecommendation = ({
  recommendedToAdd,
  isOneProduct,
  onClick,
}: LinkRecommendationProps) => {
  const { language } = useLanguage();
  const { currency } = useContextCurrency();

  return (
    <Box marginTop={'10px'}>
      <Link
        as={EActionAttribute.SPAN}
        variant={ETypographyVariant.BODY3}
        fontWeight={EFontWeight.MEDIUM}
        color={EColor.ACCENT}
        startIcon={EIcon.PLUS}
        onClick={onClick}
      >
        <Trans
          i18nKey={
            isOneProduct
              ? `${Translate.common.WIDGET}:budgetCalculator.toGetProduct`
              : `${Translate.common.WIDGET}:budgetCalculator.toGetExtraProduct`
          }
          values={{
            amount: formatCurrency(language, currency, recommendedToAdd),
          }}
          components={{
            strong: (
              <Typography
                as={EActionAttribute.SPAN}
                variant={ETypographyVariant.BODY3}
                fontWeight={EFontWeight.BOLD}
              />
            ),
          }}
        />
      </Link>
    </Box>
  );
};
